// PRD-3334 v2.2: proofs are rejected when iat is more than ~60 s off the server clock. A device
// with a wrong clock learns the offset from the server's 401 PLG_PROOF_INVALID (serverTime) and
// signs with corrected time from then on, for this browser session.

const STORAGE_KEY = "plgClockOffsetMs";

const readStored = (): number => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const n = raw === null ? 0 : Number(raw);
    return Number.isFinite(n) ? n : 0;
  } catch {
    return 0;
  }
};

let offsetMs: number | null = null;

export function getClockOffsetMs(): number {
  if (offsetMs === null) offsetMs = readStored();
  return offsetMs;
}

/** Date.now() corrected by the learned server offset. */
export const clockNowMs = (): number => Date.now() + getClockOffsetMs();

/** serverTime is unix seconds, as sent in a PLG_PROOF_INVALID error body. */
export function adjustClockFromServer(serverTime: number | undefined): void {
  if (typeof serverTime !== "number" || !Number.isFinite(serverTime)) return;
  offsetMs = serverTime * 1000 - Date.now();
  try {
    sessionStorage.setItem(STORAGE_KEY, String(offsetMs));
  } catch {
    // keeps working in memory for this page
  }
}

/** `error[0].serverTime` from the portal error envelope, if present. */
export function serverTimeFrom(payload: unknown): number | undefined {
  const first = (payload as { error?: Array<{ serverTime?: unknown }> } | null)?.error?.[0];
  return typeof first?.serverTime === "number" ? first.serverTime : undefined;
}

/** Tests: forget the in-memory offset (and the stored one unless keepStored). */
export function resetClockOffset(opts: { keepStored?: boolean } = {}): void {
  offsetMs = null;
  if (!opts.keepStored) {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
  }
}
